import api from '../utils/api';

export const reportStaticTextsService = {
  // Get all report static texts with pagination
  getReportStaticTexts: async (page = 1, limit = 10) => {
    try {
      return await api.get('/admin/report-static-texts', {
        params: { page, limit }
      });
    } catch (error) {
      console.error('Error fetching report static texts:', error);
      throw error;
    }
  },

  // Get report static text by ID
  getReportStaticTextById: async (textId) => {
    try {
      return await api.get(`/admin/report-static-texts/${textId}`);
    } catch (error) {
      console.error('Error fetching report static text by ID:', error);
      throw error;
    }
  },

  // Get report static text by module and report name
  getReportStaticTextByModuleAndReport: async (moduleName, reportName) => {
    try {
      return await api.get(`/admin/report-static-texts/by-module/${moduleName}/${reportName}`);
    } catch (error) {
      console.error('Error fetching report static text by module and report:', error);
      throw error;
    }
  },

  // Create a new report static text
  createReportStaticText: async (textData) => {
    try {
      // Send text_values as array, not as JSON string
      const payload = {
        data: {
          ...textData,
          text_values: Array.isArray(textData.text_values) 
            ? textData.text_values 
            : JSON.parse(textData.text_values)
        }
      };
      return await api.post('/admin/report-static-texts', payload);
    } catch (error) {
      console.error('Error creating report static text:', error);
      throw error;
    }
  },

  // Update an existing report static text
  updateReportStaticText: async (textId, textData) => {
    try {
      // Send text_values as array, not as JSON string
      const payload = {
        data: {
          ...textData,
          text_values: Array.isArray(textData.text_values) 
            ? textData.text_values 
            : JSON.parse(textData.text_values)
        }
      };
      return await api.put(`/admin/report-static-texts/${textId}`, payload);
    } catch (error) {
      console.error('Error updating report static text:', error);
      throw error;
    }
  },

  // Delete a report static text
  deleteReportStaticText: async (textId) => {
    try {
      return await api.delete(`/admin/report-static-texts/${textId}`);
    } catch (error) {
      console.error('Error deleting report static text:', error);
      throw error;
    }
  },
};
